import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  templateUrl: './message.dialog.html',
  styleUrls: ['./message.dialog.scss']
})
export class MessageDialog implements OnInit {
  title: string;
  message: string;
  isError = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    if (this.data.message) {
      this.message = this.data.message;
    }

    if (this.data.title) {
      this.title = this.data.title;
    }

    if (this.data.isError) {
      this.isError = true;
      this.title = 'Sorry, but an error has occurred.'
    }
  }
}
